import SignupFormComponent from "../../features/auth/components/SignupForm";

const Signup = () => {
  return (
    <>
      <SignupFormComponent />
    </>
  );
};

export default Signup;
